const GRAPHQL_URL = `${process.env.REACT_APP_API_ROOT_URL}/graphql`

export async function fetchJSON(url, options = {}) {
  if (options.body) {
    options = { ...options, body: JSON.stringify(options.body), headers: { 'Content-Type': 'application/json; charset=utf-8' } }
  }

  if (options.token) {
    options.headers = { ...options.headers, Authorization: `Bearer ${options.token}` }
  }

  const response = await fetch(url, options)

  if (!response.ok) {
    throw Error(`${response.status} ${response.statusText}`)
  }

  return response.json()
}

export async function fetchGQL(body, token) {
  return fetchJSON(GRAPHQL_URL, { body, method: 'post', token })
}



// WEBPACK FOOTER //
// ./src/services/common.js